// extracted by mini-css-extract-plugin
export default {"container":"TaskLoadingIndicator_container__ZQI1n","spinner":"TaskLoadingIndicator_spinner__0B1rt","spin":"TaskLoadingIndicator_spin__syIy2"};